module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAY0lEQVQ4y2NgGBygSPM/WZhqBvwnE8ANuCRg8h8bvmWkDca45Aka8CJPCoxJNuChv/L/v0eZ/v8/xwDGfw4zg8VIcsFdWw24ASA2yV54ni7z/2WRJBiD2HgNoDgWBj4hDW0AAMy1YnC4oUpOAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/SR.png
// module id = 1268
// module chunks = 0